import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useWindowSize } from "usehooks-ts";
import { images } from "../../constants";
import sidebarNav from "../../config/sidebarNav";
import SidebarContext from "../../store/sidebarContext";
import LoginContext from "../../store/loginContext";
import { Icon } from "@iconify/react";
import classes from "./Sidebar.module.scss";
import toast from "react-hot-toast";

function Sidebar() {
  const [activeIndex, setActiveIndex] = useState(0);
  const { width } = useWindowSize();
  const location = useLocation();
  const sidebarCtx = useContext(SidebarContext);
  const loginCtx = useContext(LoginContext);
  const isMobile = width <= 768;
  const isCollapsed = !isMobile && !sidebarCtx.isOpen;

  function openSidebarHandler() {
    if (isMobile) document.body.classList.toggle("sidebar__open");
  }

  function logoutHandler() {
    openSidebarHandler();
    localStorage.removeItem("token");
    toast.success("User Logged out successfully", {
      duration: 2000,
    });
    loginCtx.logout();
  }

  useEffect(() => {
    const curPath = window.location.pathname.split("/")[1];
    const activeItem = sidebarNav.findIndex(
      (item) => item.section.toLowerCase() === curPath
    );
    setActiveIndex(curPath.length === 0 ? 0 : activeItem);
  }, [location]);

  return (
    <div
      className={`${classes.sidebar} ${
        isCollapsed ? classes.sidebar_close : ""
      }`}
    >
      {/* <div className={classes.sidebar__logo}>
        <img
          src={sidebarCtx.isOpen ? images.logo : images.logoIcon.default}
          alt="admin-panel"
          className={classes.logoImage}
        />
      </div> */}
      <div className={classes.sidebar__logo}>
        <img
          src={isCollapsed ? images.logoIcon.default : images.logo}
          alt="admin-panel"
          className={`${classes.logoImage} ${
            isCollapsed ? classes.compactLogo : ""
          }`}
        />
      </div>

      <div className={classes.sidebar__menu}>
        {sidebarNav.map((nav, index) => (
          <Link
            to={nav.link}
            key={`nav-${index}`}
            className={`${classes.sidebar__menu__item} ${
              activeIndex === index && classes.active
            }`}
            onClick={openSidebarHandler}
          >
            <div className={classes.sidebar__menu__item__icon}>
              <Icon icon={nav.icon} />
            </div>
            <div className={classes.sidebar__menu__item__txt}>
              {nav.text}
            </div>
          </Link>
        ))}
      </div>

      <div className={[classes.sidebar__menu, classes.logout].join("")}>
        <Link
          to="/login"
          className={classes.sidebar__menu__item}
          onClick={logoutHandler}
        >
          <div className={classes.sidebar__menu__item__icon}>
            <Icon icon="tabler:logout" />
          </div>
          <div className={classes.sidebar__menu__item__txt}>Logout</div>
        </Link>
      </div>
    </div>
  );
}

export default Sidebar;
